import { Component, Input } from '@angular/core'
import { Logger } from 'common/log'
import { RouteLoggerService } from 'common/util/module'

@Component({
  templateUrl: './navigationErrorView.component.pug',
  styleUrls: ['./navigationErrorView.component.scss'],
})
export class NavigationErrorViewComponent {
  @Input() error: any
  reason = ''
  reasonText = ''
  reasonUrl = ''
  reasonCode = 0
  logger = new Logger(__filename)

  constructor (routerLogger: RouteLoggerService) {
    this.error = routerLogger.lastError
  }

  async ngOnInit () {
    const error = this.error
    if (!error) {
      return
    }

    this.reason = 'unknown'
    if (error.status) {
      this.reasonUrl = error.config?.url ?? error.url
      if (error.status === 404) {
        this.reason = 'not-found'
      } else if (error.status === 500) {
        this.reason = 'server-error'
      } else if (error.status === -1) {
        this.reason = 'connection-error'
      } else {
        this.reason = 'http-error'
        this.reasonCode = error.status
        this.reasonText = error.statusText
      }
    } else {
      this.reason = 'misc'
      this.reasonText = error
    }

    this.logger.log('Reason:', this.reason, this.reasonText)
    this.logger.log('Reason code:', this.reasonCode)
    this.logger.log('URL:', this.reasonUrl)
  }
}
